class ctxTableTreeviewToggleDirective {
    constructor() {
        this.restrict = 'A';
        this.require = '^ctxTableTreeview';
    }

    link(scope, element, attrs, trvw) {
        const node = scope.node;

        element.addClass('ivh-treeview-toggle');

        element.bind('click', function () {
            if (!trvw.isLeaf(node)) {
                scope.$apply(function () {
                    trvw.toggleExpanded(node);
                    trvw.onToggle(node);
                });
            }
        });
    }

    static directiveFactory() {
        return new ctxTableTreeviewToggleDirective();
    }
}

ctxTableTreeviewToggleDirective.directiveFactory.$inject = [];

module.exports = ctxTableTreeviewToggleDirective.directiveFactory;



// WEBPACK FOOTER //
// ./src/shared/ctxTableTree/customDirectives/ctxTableTreeviewToggle.directive.js